import { WorkerDocument } from './worker-documents'
import { Role } from './companies'
import { QualificationQuestionAnswerQuestionType } from './qualification-question-answer'
import {
  CreateQualifierQuestionGroupRequest,
  QualifierQuestionGroup,
} from './qualifier-question-group'
import { BasicOpsWorkerDetails } from './workers'

export type CreateOrientationRequest = {
  companyId: string
  orientationName: string
  steps: CreateQualifierQuestionGroupRequest[]
  requiredAtCompanyLevel: boolean
  roleIds: string[]
  skipExistingWorkersOnShifts?: boolean
  applyToPaidBackups?: boolean
}

export enum OrientationStatus {
  ACTIVE = 'ACTIVE',
  ARCHIVED = 'ARCHIVED',
}

export type Orientation = {
  id: string
  createdAt: Date
  updatedAt: Date
  orientationName: string
  orientationSteps: QualifierQuestionGroup[]
  roles: Role[]
  companyIds: string[]
  status: OrientationStatus
  applyToPaidBackups?: boolean
}

export type WorkerOrientationWorkerDetails = BasicOpsWorkerDetails & {
  documents: WorkerDocument[]
}

export type OrientationDetails = Orientation & {
  workerOrientations: WorkerOrientation[]
}

export type WorkerOrientationAnswer = {
  id: string
  createdAt: Date
  questionId: string
  response: string[]
}

export type WorkerOrientation = {
  id: string
  createdAt: Date
  updatedAt: Date
  worker: WorkerOrientationWorkerDetails
  status: WorkerOrientationStatus
  expirationDate?: Date
  cancellationReason?: WorkerOrientationCancellationReason
  notes?: string
  answers?: WorkerOrientationAnswer[]
}

export enum WorkerOrientationStatus {
  PENDING = 'PENDING',
  COMPLETED = 'COMPLETED',
  CANCELED = 'CANCELED',
  WAIVED = 'WAIVED',
}

export enum WorkerOrientationCancellationReason {
  WORKER_SHIFT_CANCELLATION = 'WORKER_SHIFT_CANCELLATION',
  ORIENTATION_REMOVAL = 'ORIENTATION_REMOVAL',
}

export const ORIENTATION_QUESTION_TYPE_TO_TITLE: Record<
  QualificationQuestionAnswerQuestionType,
  string
> = {
  [QualificationQuestionAnswerQuestionType.SIGNATURE]: 'Signature',
  [QualificationQuestionAnswerQuestionType.SINGLE_CHOICE]: 'Single choice',
  [QualificationQuestionAnswerQuestionType.PDF]: 'PDF/Video Link',
  [QualificationQuestionAnswerQuestionType.FREEFORM]: 'Text Input',
  [QualificationQuestionAnswerQuestionType.MULTIPLE_CHOICE]: 'Multi-Choice',
  [QualificationQuestionAnswerQuestionType.ACKNOWLEDGMENT]: 'Acknowledge',
  [QualificationQuestionAnswerQuestionType.VIDEO]: 'Video',
  [QualificationQuestionAnswerQuestionType.IMAGES]: 'Image',
}

export type QueryOrientationsRequest = {
  companyIds?: string[]
  orientationIds?: string[]
}

export type QuestionWithStep = {
  stepId: string
  stepTitle: string
  questionTitle: string
}
